import _ from 'lodash';
import * as graph from '@adc/sdk';
import * as constants from '@adc/constants';
export const getProductType = listing => _.get(listing, 'listing_configuration.product_type', '');
export const getAssetType = listing => _.get(listing, 'listing_configuration.asset_type', '');
const getTrusteeSale = listing => _.get(listing, 'event.trustee_sale', false);
const getVenueType = listing => _.get(listing, 'venue.venue_type', '');
const getPartyMemberByRole = (listing, role) => listing.parties?.find(party => party.party_role === role);
export const hasADCAuctioneer = listing => _.get(listing, 'listing_configuration.trustee_sales_channel') ===
    'AUCTIONEERING';
export const isLive = listing => getVenueType(listing) === constants.graph.enums.VenueType.LIVE;
export const isTPS = listing => getTrusteeSale(listing);
export const isREO = listing => !getTrusteeSale(listing);
export const isTPSLive = listing => isTPS(listing) && isLive(listing);
export const isTPSOnline = listing => isTPS(listing) &&
    getVenueType(listing) === constants.graph.enums.VenueType.ONLINE &&
    hasADCAuctioneer(listing);
export const isShortSale = listing => getProductType(listing) === constants.graph.enums.ProductType.SHORT_SALE;
export const isPrivateSeller = listing => getAssetType(listing) === graph.enums.AssetType.PrivateSeller;
export const isFCLMarketing = listing => getProductType(listing) === constants.graph.enums.ProductType.FCL_MARKETING;
export const getBrokerAgent = listing => getPartyMemberByRole(listing, constants.graph.enums.ListingPartyRole.LISTING_AGENT);
export const getForeclosureContact = listing => getPartyMemberByRole(listing, constants.graph.enums.ListingPartyRole.FORECLOSURE_ATTORNEY_CONTACT);
export const hasMarketingTag = (listing, name) => {
    return listing.marketing_tags?.find(listingTag => listingTag.tag === name);
};
export const isForeclosure = listing => listing.listing_configuration?.asset_type ===
    graph.enums.AssetType.Foreclosure;
//# sourceMappingURL=utils.js.map